import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

// Stores
import filmStore from "../Store/FilmStore";
import blockStore from "../Store/BlockStore";
import channelStore from "../Store/ChannelStore";

// Компоненты
import Header from "./Header";
import Main from "./Main.jsx";
import Api from "./Api";
import { BASE_API_URL } from "./const";

const AppWrapper = observer(({ hideMetUid }) => {
  const [responseFilter, setResponseFilter] = useState(null);
  const [sendDataFilmList, setSendDataFilmList] = useState(null);
  const [sendDataFilmListQueryFilter, setSendDataFilmListQueryFilter] =
    useState("");
    const [manageBlock, setManageBlock] = useState(false);

    // Загрузка данных при монтировании компонента
  useEffect(() => {
    getDataFilter();
    channelStore.getChannels();
    blockStore.getBlockList();
  }, []);

  // Сброс фильтра при переключении режима блоков
  useEffect(() => {
    if (manageBlock) {
      setSendDataFilmListQueryFilter("");
    }
  }, [manageBlock]);

  // Загрузка списка фильмов при изменении фильтра
  useEffect(() => {
    getDataFilmList(1);
  }, [sendDataFilmListQueryFilter]);

  // Получение списка фильтров
  async function getDataFilter() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/listFilter`);
      setResponseFilter(response.data.data);
    } catch (error) {
      console.error("Ошибка при получении фильтров:", error);
    }
  }

  const syncPresetDictionary = (presets) => {
    setResponseFilter((current) => ({
      ...current,
      preset: [...presets]
        .sort((a, b) => Number(a.id) - Number(b.id))
        .map(({ id, name }) => ({ id, name })),
    }));
  };

  // Получение списка фильмов
  async function getDataFilmList(numberPage) {
    filmStore.setLastRequestParams({
      numberPage: numberPage,
      query: sendDataFilmListQueryFilter,
      body: sendDataFilmList,
    });

    try {
      const response = await Api.post(
        `${BASE_API_URL}/api/filter?page=${numberPage}${sendDataFilmListQueryFilter}`,
        sendDataFilmList
      );

      filmStore.setResponseFilmList(response);
    } catch (error) {
      console.error("Ошибка при получении списка фильмов:", error);
    }
  }

    return (
    <>
      <Header setManageBlock={setManageBlock} manageBlock={manageBlock} />

      {responseFilter && filmStore.responseFilmList && (
                    <Main
            responseFilter={responseFilter}
            responseFilmList={filmStore.responseFilmList}
            setSendDataFilmListQueryFilter={setSendDataFilmListQueryFilter}
            setManageBlock={setManageBlock}
            getDataFilmList={getDataFilmList}
            getDataListChannels={channelStore.getChannels}
            repeatLastFilmListRequest={filmStore.repeatLastFilmListRequest}
            blockStore={blockStore}
            manageBlock={manageBlock}
            hideMetUid={hideMetUid}
            onPresetsChange={syncPresetDictionary}
          />
        )}
    </>
  );
});

export default AppWrapper;
